var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$router.currentRoute.query.next)?_c('div',{staticClass:"text-center my-4"},[_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":_vm.$router.currentRoute.query.next}},[_vm._v("\n        Next\n        "),_c('font-awesome-icon',{staticClass:"ml-2",attrs:{"icon":"arrow-right"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }